import React, { useState, useEffect } from "react";
import {  useSelector } from 'react-redux';

import {
  Modal,
  Grid,
  Button,
  Paper,
  Typography,
  
} from "@material-ui/core";
import { Search, Close } from "@material-ui/icons";

import { FormInput } from "../../../../../";
import { pathOr, clone } from "ramda";
import useStyles from "./styles";
import { Scrollbars } from 'react-custom-scrollbars';


const Filter = ({ handleClose, modalState, config, search,setFilterQuery,setFilterQueryMeta,selectedModule }) => {
  const classes = useStyles();
  
  const {filterConfig  } = useSelector((state) => state.modules);
 
  const [filterValues, setFilterValues] = useState({});
  const [filterValuesMeta, setFilterValuesMeta] = useState({});
  const [isResetFilter, setIsResetFilter] = useState(false);
  
  
const [main_advanced_fields] = useState(pathOr(
  [],
  [selectedModule,"templateMeta", "data", "advanced_search"],
  filterConfig,
));
  const [advanced_fields, setAdvancedFields] = useState(main_advanced_fields);
  useEffect(()=>{
  
    const filterValuesCopy = clone(filterValues);
  for (let val in filterValuesCopy) {
    filterValuesCopy[val] = "";
  }
  setFilterValues(filterValuesCopy);
  
  },[config]);
    
  const resetFilter = () => {
    setIsResetFilter(true)
    setAdvancedFields([])
  };
  

  useEffect(()=>{
   
    if(isResetFilter){
      //console.log("isResetFilter",filterValues,filterValuesMeta)
      const filterValuesCopy = clone(filterValues);
      const nwAFields = clone(main_advanced_fields);
      const nwAFieldsMeta = [];
      const nwAFieldsCopy = [];
     
      
    //     clone(pathOr(
    //   [],
    //   [selectedModule,"templateMeta", "data", "advanced_search"],
    //   filterConfig,
    // ));
    for (let val in nwAFields) {
let fieldName = nwAFields[val]['name'];
      if(nwAFields[val]['type']==='multienum'){
        nwAFields[val]['value']=[];
        nwAFieldsCopy[fieldName] = '';
        nwAFieldsMeta[fieldName]=nwAFields[val];
      }else if(nwAFields[val]['type']==='parent'){
        nwAFields[val]['value']='';
        nwAFields[val]['parent_name']='';
        nwAFieldsCopy[fieldName] = '';
        nwAFieldsMeta[fieldName]=nwAFields[val];
  
      }else if(nwAFields[val]['type']==='currency'){
        nwAFields[val]['value']='';
        nwAFields[val][fieldName]='';
        nwAFields[val]['range_'+fieldName]='';
        nwAFields[val]['start_range_'+fieldName]='';
        nwAFields[val]['end_range_'+fieldName]='';
        nwAFields[val][fieldName+'_range_choice']='';
        nwAFieldsCopy[fieldName] = '';
        nwAFieldsMeta[fieldName]=nwAFields[val];
  
      }else if(nwAFields[val]['type']==="datetimecombo"){
        nwAFields[val]['value']='';
        nwAFields[val][fieldName]='';
        nwAFields[val]['range_'+fieldName]='';
        nwAFields[val]['start_range_'+fieldName]='';
        nwAFields[val]['end_range_'+fieldName]='';
        nwAFields[val][fieldName+'_range_choice']='';
        nwAFieldsCopy[fieldName] = '';
        nwAFieldsMeta[fieldName]=nwAFields[val];
      }else{
        nwAFields[val]['value']='';
        nwAFieldsCopy[fieldName] = '';
        nwAFieldsMeta[fieldName]=nwAFields[val];
  
      }

    }
    setIsResetFilter(false)
    setAdvancedFields(nwAFields)
    setFilterValuesMeta(nwAFieldsMeta)
    setFilterValues(nwAFieldsCopy)
    let filterQuery = `filter[reset][eq]=true&`;
    setFilterQuery(filterQuery);
    setFilterQueryMeta('');
  }


   
   
  },[isResetFilter])

  const buildFilterQuery = () => {
    let filterQuery = "";
    let filterFields=[];
    for (let key in filterValues) {     
      // let datefield = ['datetime'];
      // if(datefield.includes(filterValuesMeta[key].type))
      // {
      //   let arr =[];
      //   arr.push(...filterValues[key]);
      //   delete filterValues[key];
      // }
      if (filterValues[key] && filterValuesMeta[key]) {
        //console.log(key,"filterQuery String",filterQuery)
      let operator = 'eq';  
      let likeTypes = ['name','url'];
      if(likeTypes.includes(filterValuesMeta[key].type))
      {
        operator= 'lke';
      }
    

      let multiTypes = ['multienum'];
      //console.log("filterValuesMeta key",key);
      if(multiTypes.includes(filterValuesMeta[key].type))
      {
        operator= 'multi';
        
      }


        if (typeof filterValues[key] !== "object") {
      
        if(filterValuesMeta[key].type==='datetime' || filterValuesMeta[key].type==='datetimecombo'){

          // console.log("filterQueryfilterQuery  Object",filterValuesMeta[key],filterValues,filterQuery);

          let dateSingleValue= ['next_7_days','last_7_days', 'last_month','this_month','next_month','last_30_days','next_30_days','this_year','last_year','next_year'];
          let dateDoubleValue= ['=', "not_equal", 'less_than', 'greater_than', 'less_than_equals', 'greater_than_equals'];
          let dateTripalValue= ['between'];

          if(dateSingleValue.some(item =>  filterValues[key]=== item)){
            filterQuery =
            filterQuery + `filter[range_${key}][${`operator`}]=${filterValues[key]}&`;
          }else if(dateDoubleValue.some(item =>  filterValues[key]=== item)){
            filterQuery =
            filterQuery + `filter[range_${key}][${operator}]=${filterValues['range_'+key]}&filter[${key}_range_choice][${`operator`}]=${filterValues[key]}&`;
          }else if(dateTripalValue.some(item =>  filterValues[key]=== item)){
            filterQuery =
            filterQuery + `filter[start_range_${key}][${operator}]=${filterValues['start_range_'+key]}&filter[end_range_${key}][${operator}]=${filterValues['end_range_'+key]}&filter[${key}_range_choice][${`operator`}]=${filterValues[key]}&`;
          }
        
        }else         if(filterValuesMeta[key].type==='currency'){

          // console.log("filterQueryfilterQuery  Object",filterValuesMeta[key],filterValues,filterQuery);

          let dateDoubleValue= ['=', "not_equal", 'less_than', 'greater_than', 'less_than_equals', 'greater_than_equals'];
          let dateTripalValue= ['between'];

          if(dateDoubleValue.some(item =>  filterValues[key]=== item)){
            filterQuery =
            filterQuery + `filter[range_${key}][${operator}]=${filterValues['range_'+key]}&filter[${key}_range_choice][${`operator`}]=${filterValues[key]}&`;
          }else if(dateTripalValue.some(item =>  filterValues[key]=== item)){
            filterQuery =
            filterQuery + `filter[start_range_${key}][${operator}]=${filterValues['start_range_'+key]}&filter[end_range_${key}][${operator}]=${filterValues['end_range_'+key]}&filter[${key}_range_choice][${`operator`}]=${filterValues[key]}&`;
          }
      // console.log("query2222222222",filterQuery)  
        }else if(filterValuesMeta[key].type==='bool'){
          filterQuery =
          filterQuery + `filter[${key}][${operator}]=${filterValues[key]?1:0}&`;
        }else{  
          let fval = encodeURIComponent(filterValues[key]);
        filterQuery =
            filterQuery + `filter[${key}][${operator}]=${fval}&`;
        }
          let fields = {};
          let value = filterValues[key];
          if(filterValuesMeta[key].type ==='enum')
          {
            value = filterValuesMeta[key].options[value];
          }
          fields.value=value;
          fields.label=filterValuesMeta[key].label;
          fields.field=key;
          filterFields.push(fields);
          
        } else {
          let fields = {};
        if(filterValuesMeta[key].type==='relate'){
          let fval = encodeURIComponent(filterValues[key].value);
          filterQuery =
          filterQuery + `filter[${key}][]=${fval}&filter[${key}_id][]=${filterValues[key].id}&`;

          fields.value=filterValues[key].value;
        }else if(filterValuesMeta[key].type==='parent'){
          // filter[parent_type][eq]=Cases&filter[parent_name][eq]=eb995f9c-35d5-6050-a1f6-5bdfcd5512c8
          let fval = encodeURIComponent(filterValues[key].parent_name);
          filterQuery =
          filterQuery + `filter[parent_type][${operator}]=${filterValues[key].parent_type}&filter[parent_name][${operator}]=${fval}&`;
          fields.value=filterValues[key].value;
        }else{
          filterQuery =
            filterQuery + `filter[${key}][${operator}]=${filterValues[key].id}&`;
            fields.value=filterValues[key].id;
          }
          fields.label=filterValuesMeta[key].label;
          fields.field=key;
          filterFields.push(fields);
        }
      } 
    }
    setFilterQuery(filterQuery);
    setFilterValuesMeta(filterValuesMeta);
    setFilterQueryMeta(filterFields);
    if(filterQuery)
    {
      return filterQuery;
    }
    else
    {
      return `filter[reset][eq]=true&`;
    }
  }

  useEffect(
		() => {
  
      let initialValues1 = [];
      let initialMetaValues1 = [];
      let initialValuesClone = clone(filterValues);
      let initialMetaValuesClone = clone(filterValuesMeta);
    
        let advanced_fields1 = pathOr(
          [],
          [selectedModule,"templateMeta", "data", "advanced_search"],
          filterConfig,
        );
      
        advanced_fields1.map((fieldsMeta, key) => {
          // console.log("metaaaa",key,fieldsMeta)
          let value = Array.isArray(fieldsMeta.value) ? fieldsMeta.value.toString() : fieldsMeta.value;
          
          if (value) {   
            if(fieldsMeta.type === "datetimecombo" && fieldsMeta.value == "between")
            {
              //console.log("value",fieldsMeta.value);
              ///console.log(fieldsMeta["end_range_"+fieldsMeta.field_key]);
              
              initialValues1[fieldsMeta.field_key] = fieldsMeta.value.toString();
              initialValues1["end_range_"+fieldsMeta.field_key] = fieldsMeta["end_range_"+fieldsMeta.field_key];
              initialValues1["start_range_"+fieldsMeta.field_key] = fieldsMeta["start_range_"+fieldsMeta.field_key];
              /*initialValues1[fieldsMeta.field_key+"_range_choice"] = fieldsMeta.value.toString();
              initialValues1["range_"+fieldsMeta.field_key] = fieldsMeta.value.toString();*/
              
              initialMetaValues1[fieldsMeta.field_key] = fieldsMeta;
              initialMetaValues1["end_range_"+fieldsMeta.field_key] = fieldsMeta;
              initialMetaValues1["start_range_"+fieldsMeta.field_key] = fieldsMeta;
              /*initialMetaValues1[fieldsMeta.field_key+"_range_choice"] = fieldsMeta;
              initialMetaValues1["range_"+fieldsMeta.field_key] = fieldsMeta;*/
            }
            else if(fieldsMeta.type ==='relate'){
              let temp = [];
              temp['value'] = fieldsMeta.value.value;
              temp['id'] = fieldsMeta.value.id;
              initialValues1[fieldsMeta.field_key] = temp;
              initialMetaValues1[fieldsMeta.field_key] = fieldsMeta;
              //initialValues1[fieldsMeta.field_key]['id'] = fieldsMeta.value.id;
            }
            else if(fieldsMeta.type ==='parent'){
              // filter[parent_type][eq]=Cases&filter[parent_name][eq]=eb995f9c-35d5-6050-a1f6-5bdfcd5512c8
              // console.log("dsadada",fieldsMeta);
              let temp = [];
              temp['parent_name'] = fieldsMeta.parent_name.parent_name;
              temp['parent_type'] = fieldsMeta.parent_name.parent_type;
              temp['parent_id'] = fieldsMeta.parent_name.parent_id;
              initialValues1[fieldsMeta.field_key] = temp; 
              initialMetaValues1[fieldsMeta.field_key] = fieldsMeta;             
            }
            else
            {
              initialValues1[fieldsMeta.field_key] = fieldsMeta.value.toString();
              initialMetaValues1[fieldsMeta.field_key] = fieldsMeta;
            }
          }
        });






        
        setFilterValuesMeta({...filterValuesMeta, ...initialMetaValues1});
        setFilterValues({...filterValues,...initialValues1});
        
     // }
    
    },
		[modalState]
	);

  const renderTabBody = () => {
     
// let newAdFields = isResetFilter?advanced_fields:pathOr(
//   [],
//   [selectedModule,"templateMeta", "data", "advanced_search"],
//   filterConfig,
// );

const currencyIndex = advanced_fields.findIndex(it => it.type === "currency");
const currencyField = advanced_fields.splice(currencyIndex, 1);
advanced_fields.push(...currencyField);

const searchFormHandle = (event) => {
  console.log(event)
  console.log(event.target.id, "filter form id")
  event.preventDefault()
  search(buildFilterQuery())
}

//console.log("adddddvanced_search2222",isResetFilter,advanced_fields,filterValues)  

    return (
      <form id='filter-form' onSubmit={searchFormHandle}  noValidate autoComplete="off" 
      className={ selectedModule === "Contacts" ? classes.formCont : '' }>
      <Grid container spacing={2} className={classes.fieldsGrid}>
        {advanced_fields && advanced_fields.map((field) => (
          // console.log("fieldfield",filterValues),
          /*<Grid item xs={field.type === "currency" ? 12 : 6} md={field.type === "currency" ? 8 : 4} key={field.field_key}>*/
          <Grid item xs={field.type === "currency" ? 6 : 6} md={field.type === "currency" ? 4 : 4} key={field.field_key}>
            <FormInput
              field={field}
              dynamicEnumValue={filterValues[field.parentenum] || ""}
              onChange={(val) => {              
                //console.log("Chnage value ",val);  
                //console.log("filterValues",filterValues);  

                if(field.type==='multienum')
                {
                  if(Array.isArray(val))
                  {
                    val = val.toString();
                  }
                }
                
                

                if(field.type==='datetime' || field.type==='datetimecombo')
                {
                  let dateSingleValue= ['next_7_days','last_7_days', 'last_month','this_month','next_month','last_30_days','next_30_days','this_year','last_year','next_year'];
                  let dateDoubleValue= ['=', "not_equal", 'less_than', 'greater_than', 'less_than_equals', 'greater_than_equals'];
                  let dateTripalValue= ['between'];

                  if(dateSingleValue.some(item =>  val['value'] === item)){
                    setFilterValues({ ...filterValues, [field.field_key]: val['value'],[`range_${field.field_key}`]: '' });
                  }else if(dateDoubleValue.some(item =>  val['value'] === item)){
                    setFilterValues({ ...filterValues, [field.field_key]: val['value'],[`${field.field_key}_range_choice`]: '', [`range_${field.field_key}`]: val[`range_${field.field_key}`] });
                  }else if(dateTripalValue.some(item =>  val['value'] === item)){
                    setFilterValues({ ...filterValues, [`range_${field.field_key}`]:'',[`${field.field_key}_range_choice`]:'',[field.field_key]: val[`${field.field_key}`], [`start_range_${field.field_key}`]: val[`start_range_${field.field_key}`],[`end_range_${field.field_key}`]: val[`end_range_${field.field_key}`] });
                  }
                  else
                  {
                    setFilterValues({ ...filterValues, [`range_${field.field_key}`]:'',[`${field.field_key}_range_choice`]:'',[field.field_key]: val[`${field.field_key}`], [`start_range_${field.field_key}`]: '',[`end_range_${field.field_key}`]: '' });
                  }
                  
                  //setFilterValues({ ...filterValues,[field.field_key]: val[`${field.field_key}`], [`${field.field_key}_range_choice`]: val[`${field.field_key}_range_choice`], [`range_${field.field_key}`]: val[`range_${field.field_key}`],[`start_range_${field.field_key}`]: val[`start_range_${field.field_key}`],[`end_range_${field.field_key}`]: val[`end_range_${field.field_key}`] });
                 
                  setFilterValuesMeta({ 
                    ...filterValuesMeta, 
                    [field.field_key]: field,
                    [`${field.field_key}_range_choice`]: field, 
                    [`range_${field.field_key}`]: field,
                    [`start_range_${field.field_key}`]: field,
                    [`end_range_${field.field_key}`]: field 
                  });
                }
                else  if(field.type==='currency')
                {
                  // alert(val['value'])
                  // let dateSingleValue= ['next_7_days','last_7_days', 'last_month','this_month','next_month','last_30_days','next_30_days','this_year','last_year','next_year'];
                  let dateDoubleValue= ['=', "not_equal", 'less_than', 'greater_than', 'less_than_equals', 'greater_than_equals'];
                  let dateTripalValue= ['between'];

                  // if(dateSingleValue.some(item =>  val['value'] === item)){
                  //   setFilterValues({ ...filterValues, [field.field_key]: val['value'],[`range_${field.field_key}`]: '' });
                  // }else 
                  if(dateDoubleValue.some(item =>  val[field.field_key] === item)){
                    setFilterValues({ ...filterValues, [field.field_key]: val[field.field_key],[`${field.field_key}_range_choice`]: '', [`range_${field.field_key}`]: val[`range_${field.field_key}`] });
                  }else if(dateTripalValue.some(item =>  val[field.field_key] === item)){
                    setFilterValues({ ...filterValues, [`range_${field.field_key}`]:'',[`${field.field_key}_range_choice`]:'',[field.field_key]: val[`${field.field_key}`], [`start_range_${field.field_key}`]: val[`start_range_${field.field_key}`],[`end_range_${field.field_key}`]: val[`end_range_${field.field_key}`] });
                  }
                  else
                  {
                    setFilterValues({ ...filterValues, [`range_${field.field_key}`]:'',[`${field.field_key}_range_choice`]:'',[field.field_key]: val[`${field.field_key}`], [`start_range_${field.field_key}`]: '',[`end_range_${field.field_key}`]: '' });
                  }
                  
                  //setFilterValues({ ...filterValues,[field.field_key]: val[`${field.field_key}`], [`${field.field_key}_range_choice`]: val[`${field.field_key}_range_choice`], [`range_${field.field_key}`]: val[`range_${field.field_key}`],[`start_range_${field.field_key}`]: val[`start_range_${field.field_key}`],[`end_range_${field.field_key}`]: val[`end_range_${field.field_key}`] });
                 
                  setFilterValuesMeta({ 
                    ...filterValuesMeta, 
                    [field.field_key]: field,
                    [`${field.field_key}_range_choice`]: field, 
                    [`range_${field.field_key}`]: field,
                    [`start_range_${field.field_key}`]: field,
                    [`end_range_${field.field_key}`]: field 
                  });
                }
                else
                {
                  if(field)
                  {
                    setFilterValues({ ...filterValues, [field.field_key]: val });
                    setFilterValuesMeta({ ...filterValuesMeta, [field.field_key]: field });
                  }
                }
                // console.log("filterValues inside form",field); 
                // console.log("filterValues inside form",filterValues);  
                // console.log('filterValues val',val);
              }
              }
              small={true}
              value={filterValues[field.field_key] || ""}
              view={'SearchLayout'}
              
            />
          </Grid>
        ))}
        <div className={classes.buttonsWrapper}>
          <Button
            variant="contained" //text
            onClick={() => resetFilter()}
            color="primary"
            size="medium"
            className={classes.btn}
            disableElevation
            type="button"
            
          >
           <Close /> Reset
          </Button>

          <Button
            variant="contained"
            onClick={() => search(buildFilterQuery())}
            color="primary"
            size="medium"
            className={classes.btn}
            disableElevation
            type="submit"
            style={{ margin: 5, width: "100px" }}
            form='filter-form'
          >
            <Search /> Search
          </Button>

        </div>
      </Grid>
      </form>
    );
  };

  const renderBody = () => (
    <Scrollbars>
    <Paper square className={classes.paper}>
      <div className={classes.titleHeadWrapper}>
          <Typography variant="subtitle1">
            Search
          </Typography>
          <Close
            onClick={handleClose}
            className={classes.closeIcon}
          />
        </div>
      
      {renderTabBody()}
      
    </Paper>
    </Scrollbars>
  );

  return (
    <Modal
      open={modalState}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      {renderBody()}
    </Modal>
  );
};

export default Filter;